export const DEFAULT_BLOCK_CONFIGS = {
  spacer: {
    height: 20,
  },
  header: {
    text: "Текст верхнего колонтитула",
  },
  footer: {
    text: "Текст нижнего колонтитула",
  },
  text: {
    sequence: true,
    label: "Заголовок блока",
    text: "Текст содержимого {{ record.id }}",
    style: {},
  },
  table: {
    sequence: true,
    label: "Название таблицы",
    headers: ["Название", "Вес", "Объем"],
    rows: [
      [
        "{{ record.cargo_name }}",
        "{{ record.cargo_weight }} кг",
        "{{ record.cargo_volume }} м³",
      ],
    ],
    style: {},
  },
  items_table: {
    trip_vehicles: {
      sequence: true,
      label: "Выделенный подвижной состав",
      headers: ["Название", "Гос номер", "Роль"],
      data_source: "trip_vehicles",
      rows: [
        "{{ item.vehicle.model }}",
        "{{ item.vehicle.registration_number }}",
        "{{ item.human_role }}",
      ],
      style: {},
    },
    trip_drivers: {
      sequence: true,
      label: "Выделенный водительский состав",
      headers: ["ФИО", "Роль", "Телефон", "Водительское", "Паспорт"],
      data_source: "trip_drivers",
      rows: [
        "{{ item.driver.last_name }} {{ item.driver.first_name }} {{ item.driver.middle_name }}",
        "{{ item.human_role }}",
        "{{ item.driver.phone }}",
        "{{ item.driver.driver_license.series }} {{ item.driver.driver_license.number }}",
        "{{ item.driver.driver_passport.series }} {{ item.driver.driver_passport.number }}",
      ],
      style: {},
    },
    order_points: {
      sequence: true,
      label: "Точки маршрута",
      headers: ["Тип точки", "Адрес", "Дата и время"],
      data_source: "order_points",
      rows: [
        "{{ item.human_point_type }}",
        "{{ item.address }}",
        "{{ item.planned_datetime | human_datetime }}",
      ],
      style: {},
    },
  },
  sectioned_items_table: {
    trip_vehicles: {
      data_source: "trip_vehicles",
      sequence: true,
      number_section: true,
      number_cells: false,
      section_label:
        "Транспорт: {{ item.vehicle.model }} ({{ item.vehicle.registration_number }})",
      headers: ["Параметр", "Значение"],
      rows: [
        ["Роль", "{{ item.human_role }}"],
        ["Модель", "{{ item.vehicle.model }}"],
        ["Гос. номер", "{{ item.vehicle.registration_number }}"],
        ["Тип кузова", "{{ item.vehicle.body_type }}"],
      ],
      style: {},
    },
    trip_drivers: {
      data_source: "trip_drivers",
      sequence: true,
      number_section: true,
      number_cells: false,
      section_label:
        "Водитель: {{ item.driver.last_name }} {{ item.driver.first_name }} {{ item.driver.middle_name }}",
      headers: ["Параметр", "Значение"],
      rows: [
        ["Роль", "{{ item.human_role }}"],
        ["Телефон", "{{ item.driver.phone }}"],
        [
          "Водительское удостоверение",
          "{{ item.driver.driver_license.series }} {{ item.driver.driver_license.number }}",
        ],
        [
          "Паспорт",
          "{{ item.driver.driver_passport.series }} {{ item.driver.driver_passport.number }}",
        ],
      ],
      style: {},
    },
    order_points: {
      data_source: "order_points",
      sequence: true,
      number_section: true,
      number_cells: false,
      section_label: "{{ item.human_point_type }}",
      headers: [],
      rows: [
        [
          "Дата: {{ item.planned_datetime | human_datetime }}",
          "Адрес: {{ item.address }}",
        ],
        [
          "Способ разгрузки/погрузки: {{ item.human_loading_method }}",
          "Комментарий: {{ item.comment }}",
        ],
      ],
      style: {},
    },
  },
  side_by_side: {
    blocks: [
      {
        align: "left",
        label: "{{ record.customer.name }}",
        fields: [
          {
            label: "ИНН",
            value: "{{ record.customer.inn }}",
          },
          {
            label: "Юридический адрес",
            value:
              "{{ record.customer.requisite.addresses.legal_address }}",
          },
          {
            label: "Почтовый адрес",
            value:
              "{{ record.customer.requisite.addresses.postal_address }}",
          },
          {
            label: "Р.счет",
            value:
              "{{ record.customer.requisite.bank_details.account_number }}",
          },
          {
            label: "К.счет",
            value:
              "{{ record.customer.requisite.bank_details.correspondent_account }}",
          },
          {
            label: "БИК",
            value: "{{ record.customer.requisite.bank_details.bik }}",
          },
          {
            label: "Банк",
            value:
              "{{ record.customer.requisite.bank_details.bank_name }}",
          },
        ],
      },
      {
        align: "right",
        label: "{{ record.forwarder.name }}",
        fields: [
          {
            label: "ИНН",
            value: "{{ record.forwarder.inn }}",
          },
          {
            label: "Юридический адрес",
            value:
              "{{ record.forwarder.requisite.addresses.legal_address }}",
          },
          {
            label: "Почтовый адрес",
            value:
              "{{ record.forwarder.requisite.addresses.postal_address }}",
          },
          {
            label: "Р.счет",
            value:
              "{{ record.forwarder.requisite.bank_details.account_number }}",
          },
          {
            label: "К.счет",
            value:
              "{{ record.forwarder.requisite.bank_details.correspondent_account }}",
          },
          {
            label: "БИК",
            value:
              "{{ record.forwarder.requisite.bank_details.bik }}",
          },
          {
            label: "Банк",
            value:
              "{{ record.forwarder.requisite.bank_details.bank_name }}",
          },
        ],
      },
    ],
  },
  signature: {
    fields: [
      { label: "Заказчик", value: "{{ record.customer_name }}" },
      { label: "Экспедитор", value: "{{ record.forwarder_name }}" },
    ],
    show_lines: true,
    style: {},
  },
};
